var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownicon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01229 0C7.2775 0 7.53186 0.105357 7.71939 0.292893C7.90693 0.48043 8.01229 0.734784 8.01229 1V12.586L12.3053 8.293C12.4939 8.11084 12.7465 8.01005 13.0087 8.01233C13.2709 8.0146 13.5217 8.11977 13.7071 8.30518C13.8925 8.49059 13.9977 8.7414 14 9.0036C14.0022 9.2658 13.9014 9.5184 13.7193 9.707L7.71929 15.707C7.53176 15.8945 7.27745 15.9998 7.01229 15.9998C6.74712 15.9998 6.49282 15.8945 6.30529 15.707L0.305288 9.707C0.209778 9.61475 0.133596 9.50441 0.0811869 9.3824C0.0287779 9.2604 0.00119157 9.12918 3.77571e-05 8.9964C-0.00111606 8.86362 0.0241854 8.73194 0.0744663 8.60905C0.124747 8.48615 0.199 8.3745 0.292893 8.28061C0.386786 8.18671 0.498438 8.11246 0.621334 8.06218C0.744231 8.0119 0.87591 7.9866 1.00869 7.98775C1.14147 7.9889 1.27269 8.01649 1.39469 8.0689C1.5167 8.12131 1.62704 8.19749 1.71929 8.293L6.01229 12.586V1C6.01229 0.734784 6.11765 0.48043 6.30518 0.292893C6.49272 0.105357 6.74707 0 7.01229 0Z",
    fill: "url(#paint0_linear_1375_2714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1375_2714",
    x1: 0,
    y1: 7.99989,
    x2: 14,
    y2: 7.99989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownicon2);
export default __webpack_public_path__ + "static/media/down icon 2.56b0eedff7252802fc37690a7b9de84a.svg";
export { ForwardRef as ReactComponent };